/**
 * 計助（Keisuke）メイン画面
 * V1: Prism 風ワークスペース（/keisuke）
 */

import { Routes, Route, Navigate } from 'react-router-dom';
import PageMeta from '../components/common/PageMeta';
import KeisukeDashboard from '../components/systems/keisuke/dashboard/KeisukeDashboard';
import KeisukePageStructuredData from '../components/systems/keisuke/KeisukePageStructuredData';
import KeisukeFormulasPage from './KeisukeFormulasPage';
import KeisukeDiscussionSection from './KeisukeDiscussionSection';
import { usePublicPathLocale } from '../hooks/usePublicPathLocale';
import { keisukePublicPath } from '../utils/keisukePath';

const dashboardWrapperStyle: React.CSSProperties = {
  flex: '1 1 auto',
  minHeight: 0,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
};

export default function KeisukeManager() {
  const pathLocale = usePublicPathLocale();
  const metaPath = keisukePublicPath(pathLocale).replace(/^\//, '');

  return (
    <>
      <PageMeta
        titleKey="keisuke.title"
        descriptionKey="home.feature_keisuke_description"
        path={metaPath}
        llmsDescribedBy
      />
      <KeisukePageStructuredData />
      <Routes>
        <Route
          index
          element={
            <div style={dashboardWrapperStyle} className="keisuke-dashboard-wrapper">
              <KeisukeDashboard />
            </div>
          }
        />
        <Route path="formulas" element={<KeisukeFormulasPage />} />
        <Route path="discussion/*" element={<KeisukeDiscussionSection />} />
        <Route path="*" element={<Navigate to="/keisuke" replace />} />
      </Routes>
    </>
  );
}
